import { useMemo } from 'react';

import { ScannerHostIdentificationScanningIntensity } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

export type HostIdScanIntensityOption = {
  label: string;
  value: ScannerHostIdentificationScanningIntensity;
};

export const useHostIdScanIntensityOptions =
  (): HostIdScanIntensityOption[] => {
    const { t } = useTranslation('telemetryScannerConfig', {
      keyPrefix: 'hostIdentificationScanIntensity.options',
    });
    return useMemo(
      () =>
        Object.values(ScannerHostIdentificationScanningIntensity).map(
          (value) => ({
            label: t(value),
            value,
          }),
        ),
      [t],
    );
  };
